import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { HdBodygraphPlanetaryActivation } from '../../hd-bodygraph.models';
import { HdPlanetActivationBlockClickEvent } from '../hd-planet-activation-block/hd-planet-activation-block.component';
import { HD_PLANET_DISPLAY_CONFIGS, HdPlanetDisplayConfig, HdFixingState } from '../hd-planet-display-config';
import { findActivationFromList } from '../hd-planet-grid.utils';
import { HdJustNowLineDataResolver, resolveHdJustNowTransitFixing } from '../hd-just-now-fixing.utils';
import { HdJustNowPlanetActivationCellComponent } from '../hd-just-now-planet-activation-cell/hd-just-now-planet-activation-cell.component';
import { HdSimpleExtraPlanetVm } from '../hd-simple-planet-grid/hd-simple-planet-grid.component';

export interface HdJustNowTransitPlanetGridLabels {
  readonly title: string;
}

interface HdJustNowTransitPlanetRowVm {
  readonly displayConfig: HdPlanetDisplayConfig;
  readonly activation: HdBodygraphPlanetaryActivation | null;
  readonly fixing: HdFixingState;
}

@Component({
  selector: 'hd-just-now-transit-planet-grid',
  templateUrl: './hd-just-now-transit-planet-grid.component.html',
  styleUrl: './hd-just-now-transit-planet-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HdJustNowPlanetActivationCellComponent],
})
export class HdJustNowTransitPlanetGridComponent {
  readonly activations = input.required<readonly HdBodygraphPlanetaryActivation[]>();
  readonly lineData = input.required<HdJustNowLineDataResolver>();
  readonly labels = input.required<HdJustNowTransitPlanetGridLabels>();
  /** Optioneel informatief Chiron-item van het transit-moment (gedimde rij onderaan). */
  readonly chiron = input<HdSimpleExtraPlanetVm | null>(null);
  readonly contextMenuEnabled = input(true);

  readonly planetActivationClicked = output<HdPlanetActivationBlockClickEvent>();
  readonly planetBlockContextMenuRequested = output<{ gate: number; position: { x: number; y: number } }>();

  protected readonly rows = computed<readonly HdJustNowTransitPlanetRowVm[]>(() => {
    const activations = this.activations();
    const lineData = this.lineData();
    return HD_PLANET_DISPLAY_CONFIGS.map(displayConfig => {
      const activation = findActivationFromList(activations, 'personality', displayConfig.planetId) ?? null;
      return {
        displayConfig,
        activation,
        fixing: activation ? resolveHdJustNowTransitFixing(activation, lineData) : 'none',
      };
    });
  });
}
